const o = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path d="M12 23.25V.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M22.5 11.25 12 .75 1.5 11.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
export {
  o as default
};
